/**
 * "What's in Archive" — the in-app bullet list Isaac asked for, so anyone can see what this
 * feature does (and doesn't yet) without digging through chats. Mirrored in docs/ARCHIVE.md.
 * Keep it honest: only list what the code actually does.
 */
export const ARCHIVE_NOTES = [
  {
    title: "What it does",
    items: [
      "Opens several of your uploads as ONE sheet — filter, sort, search, tick and export across all of them.",
      "Every clip keeps a colour stripe and a V1/V2 badge for the video it came from; click a source chip to hide/show a whole video.",
      "Speakers are per video (A·1 = speaker A of video 1). Give two of them the same name and they become ONE person everywhere — filters, headings, the AI, the export.",
      "Black Cherry (chat and copy-paste) is told about every video, every speaker and which speakers you linked; its picks come back with the right video on each clip.",
      "Export MP4 / Super Cut / GIF / MP3 / SRT / VTT / audio+logo: each clip is cut from its own video, then stitched in your pick order.",
      "Click the LIST/PICK time heading (or the toolbar's Chrono button) to sort by timecode — across videos, so a clip at 0:05 of one sits beside 0:05 of another.",
      "The Play button shows how long your picked clips run (\"Play 4 · 1:12\"), the same total the export uses.",
      "Subtitle files from an archive name the video on every line and run on the stitched timeline, so they match the video you exported.",
      "A source that only holds audio (a Premiere-panel transcript keeps its picture in Premiere) shows up as a black caption card in the stitched video; the other clips keep their picture.",
      "The timeline dock and Play Selected play clips from their own videos.",
      "Translations, virality scores, filler tags and speaker links are remembered per combination of videos.",
    ],
  },
  {
    title: "How to use it",
    items: [
      "My Library → Uploads → Combine → tick 2+ videos → Open as one sheet. Or /archive/ to pick.",
      "Link a speaker across videos: click the speaker cell (or open Speakers up top) and type the same name on both.",
      "Ask Cherry to “cross-cut the videos” or “follow one speaker across every video”.",
    ],
  },
  {
    title: "Not yet",
    items: [
      "Premiere XML and the zip-of-SRTs export (single-video only for now).",
      "Segment by seconds/words across videos, share links for an archive, and the phone→Premiere remote.",
      "Uploads are still one file at a time — the archive combines finished transcripts; it doesn't stitch files.",
    ],
  },
];
